class PartyApi {

  constructor(authToken) {
    this.authToken = authToken;
  }

  headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  BASE_URL = 'https://d2bazeiz5asygt.cloudfront.net/party';

  createHeaders() {
    return this.authToken ? {
      ...this.headers,
      'Authorization': 'Bearer ' + this.authToken
    } : this.headers;
  }

  async searchByName(name, page = 0, size = 20) {
    const params = new URLSearchParams({name, page, size});
    return await fetch(`${this.BASE_URL}/searchByName?${params.toString()}`, {
      method: 'GET',
      headers: this.createHeaders()
    });
  }

  async suggestName(name) {
    return await fetch(`${this.BASE_URL}/suggestName?name=${encodeURIComponent(name)}`, {
      method: 'GET',
      headers: this.createHeaders()
    });
  }
}

export default PartyApi;
